/* Health Routine UK — product page behaviour (gallery, options, Kaching sync, label drawer, delivery estimate, sticky bar). */
function hrpInit(root) {
  if (!root || root.__hrp) return; root.__hrp = true;
  var sid = root.getAttribute('data-hrp');
  var moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';
  function money(c) {
    var v = (c / 100).toFixed(2), parts = v.split('.');
    var w = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return w;
      if (k === 'amount_with_comma_separator') return parts[0] + ',' + parts[1];
      return w + '.' + parts[1];
    });
  }
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-hrp-variants="' + sid + '"]').textContent); } catch (e) {}
  var form = root.querySelector('[data-hrp-form]');
  var idInput = root.querySelector('[data-hrp-id]');
  var box = form ? form.querySelector('.hrp-box') : null;
  var atc = root.querySelector('[data-hrp-atc]');
  var atcPrice = root.querySelector('[data-hrp-atc-price]');
  var atcLabel = root.querySelector('[data-hrp-atc-label]');
  var atcText = atcLabel ? atcLabel.textContent : '';
  var stickyPrice = root.querySelector('[data-hrp-sticky-price]');
  var err = root.querySelector('[data-hrp-error]');

  /* ---- Gallery ---- */
  var track = root.querySelector('[data-hrp-track]');
  var slides = track ? track.children : [];
  var thumbs = root.querySelectorAll('[data-hrp-thumb]');
  var dots = root.querySelectorAll('.hrp-gal__dot');
  var countEl = root.querySelector('[data-hrp-count]');
  var cur = 0;
  function go(i, smooth) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    setActive(i);
  }
  function setActive(i) {
    cur = i;
    thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
    dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === i)); });
    if (countEl) countEl.textContent = i + 1;
  }
  if (track) {
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) setActive(i); }, 60);
    }, { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-hrp-thumb')); }); });
  var pv = root.querySelector('[data-hrp-prev]'), nx = root.querySelector('[data-hrp-next]');
  if (pv) pv.addEventListener('click', function () { go(cur - 1); });
  if (nx) nx.addEventListener('click', function () { go(cur + 1); });
  function goMedia(id) {
    if (!id) return;
    for (var i = 0; i < slides.length; i++) { if (slides[i].getAttribute('data-media-id') === String(id)) { go(i); return; } }
  }

  /* ---- Variants ---- */
  function find(id) { for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return null; }
  function render(v) {
    if (!v) { if (atc) atc.disabled = true; if (atcLabel) atcLabel.textContent = 'Unavailable'; return; }
    idInput.value = v.id;
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    var p = money(v.price);
    var now = root.querySelector('[data-hrp-now]'), was = root.querySelector('[data-hrp-was]');
    if (now) now.textContent = p;
    var showCmp = root.querySelector('[data-hrp-price][data-compare="true"]');
    if (was) { was.hidden = !(showCmp && v.compare > v.price); was.textContent = money(v.compare); }
    if (!kaching) { if (atcPrice) atcPrice.textContent = p; if (stickyPrice) stickyPrice.textContent = p; }
    if (atc) atc.disabled = !v.available;
    if (atcLabel) atcLabel.textContent = v.available ? atcText : 'Sold out';
    var stock = root.querySelector('[data-hrp-stock]');
    if (stock) { stock.classList.toggle('hrp-stock--out', !v.available); }
    goMedia(v.media);
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
  }
  root.querySelectorAll('[data-hrp-variant]').forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) render(find(+r.value)); });
  });
  var optSets = root.querySelectorAll('[data-hrp-option]');
  if (optSets.length) {
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-hrp-optval]')) return;
      var sel = [];
      optSets.forEach(function (fs) { var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null); });
      var match = variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
      render(match || null);
    });
  }

  /* ---- Kaching Bundles ---- */
  var kaching = false;
  var appHost = root.querySelector('[data-hrp-app]');
  function kachingPrice() {
    var sel = form.querySelector('.kaching-bundles__bar--selected, .kaching-bundles__bar:has(input:checked)');
    if (!sel) return null;
    var el = sel.querySelector('.kaching-bundles__bar-price, [class*="bar-price"]:not([class*="full"])');
    return el ? el.textContent.trim() : null;
  }
  function syncKaching() {
    var w = form && form.querySelector('.kaching-bundles, kaching-bundles-block, [class*="kaching-bundles__"]');
    var on = !!w;
    if (on !== kaching) {
      kaching = on; if (box) box.classList.toggle('is-kaching', on);
      /* Kaching builds its deals from the selected variant, so start from the single pack. */
      if (on && variants.length > 1 && variants[0].available && idInput && idInput.value !== String(variants[0].id)) {
        idInput.value = variants[0].id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (kaching) {
      var kp = kachingPrice();
      if (atcPrice) { atcPrice.textContent = kp || ''; atcPrice.hidden = !kp; }
      if (stickyPrice) stickyPrice.textContent = kp || '';
      if (atc) atc.classList.toggle('hrp-atc--center', !kp);
    }
  }
  if (form && window.MutationObserver) {
    var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(syncKaching, 80); });
    mo.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked'] });
    form.addEventListener('change', function () { setTimeout(syncKaching, 50); });
    form.addEventListener('click', function () { setTimeout(syncKaching, 50); });
    syncKaching();
  }

  /* ---- Add to basket (native mode; Kaching handles its own add) ---- */
  if (form) form.addEventListener('submit', function (e) {
    if (kaching) return;
    e.preventDefault();
    if (!atc || atc.disabled) return;
    if (err) err.hidden = true;
    atc.classList.add('is-loading');
    var fd = new FormData(form);
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (err) { err.textContent = res.j.description || res.j.message || 'Sorry, something went wrong.'; err.hidden = false; } return; }
        if (!window.HRCart) location.href = '/cart';
      })
      .catch(function () { form.submit(); })
      .finally(function () { atc.classList.remove('is-loading'); });
  });

  /* ---- Goes well with ---- */
  root.querySelectorAll('[data-hrp-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var id = +b.getAttribute('data-hrp-add'); b.classList.add('is-loading');
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { if (!window.HRCart && r.ok) location.href = '/cart'; })
        .finally(function () { b.classList.remove('is-loading'); });
    });
  });

  /* ---- Accordions: one open at a time ---- */
  var acc = root.querySelectorAll('[data-hrp-acc] details');
  acc.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) acc.forEach(function (o) { if (o !== d) o.open = false; }); }); });

  /* ---- Label drawer ---- */
  var drawer = root.querySelector('[data-hrp-drawer]'), lastFocus = null;
  function openDrawer() {
    if (!drawer) return; lastFocus = document.activeElement;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('hrp-lock');
    var c = drawer.querySelector('.hrp-drawer__close'); if (c) setTimeout(function () { c.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('hrp-lock');
    if (lastFocus) try { lastFocus.focus(); } catch (e) {}
  }
  root.querySelectorAll('[data-hrp-open-label]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-hrp-open-label-ext]')) { e.preventDefault(); openDrawer(); } });
  if (drawer) {
    drawer.querySelectorAll('[data-hrp-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }
  window.HRPOpenLabel = openDrawer;

  /* ---- Delivery estimate (UK time, working days, bank holidays) ---- */
  var del = root.querySelector('[data-hrp-delivery]');
  if (del && window.Intl) {
    try {
      var cutoff = +del.getAttribute('data-cutoff') || 23;
      var same = del.getAttribute('data-same') === 'true';
      var dmin = +del.getAttribute('data-min') || 2, dmax = +del.getAttribute('data-max') || dmin;
      var hols = (del.getAttribute('data-hols') || '').split(/[\s,;]+/).filter(Boolean);
      var parts = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      var today = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12));
      var hour = +parts.hour % 24;
      function iso(d) { return d.toISOString().slice(0, 10); }
      function working(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && hols.indexOf(iso(d)) === -1; }
      function add1(d) { return new Date(d.getTime() + 864e5); }
      function nextWorking(d) { d = add1(d); while (!working(d)) d = add1(d); return d; }
      function addWorking(d, n) { for (var i = 0; i < n; i++) d = nextWorking(d); return d; }
      var dispatch;
      if (!working(today)) dispatch = nextWorking(today);
      else if (hour < cutoff) dispatch = same ? today : nextWorking(today);
      else dispatch = same ? nextWorking(today) : nextWorking(nextWorking(today));
      var a = addWorking(dispatch, dmin), b = addWorking(dispatch, dmax);
      var fmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
      var isToday = iso(dispatch) === iso(today);
      var dl = isToday ? 'today' : (iso(dispatch) === iso(add1(today)) ? 'tomorrow' : fmt.format(dispatch));
      var orderBy = (working(today) && hour < cutoff) ? 'Order by ' + (cutoff === 12 ? '12pm' : (cutoff > 12 ? (cutoff - 12) + 'pm' : cutoff + 'am')) + ' for dispatch ' + dl : 'Order now for dispatch ' + dl;
      del.querySelector('[data-hrp-dispatch]').innerHTML = '<strong>' + orderBy + '</strong>';
      var eta = del.querySelector('[data-hrp-eta]');
      eta.textContent = ' · Estimated delivery ' + (dmin === dmax ? fmt.format(a) : fmt.format(a) + ' – ' + fmt.format(b));
      eta.hidden = false;
    } catch (e) {}
  }

  /* ---- Sticky bar ---- */
  var sticky = root.querySelector('[data-hrp-sticky]');
  if (sticky && atc && 'IntersectionObserver' in window) {
    var past = false;
    new IntersectionObserver(function (en) {
      var e = en[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', past); sticky.setAttribute('aria-hidden', String(!past));
      var btn = sticky.querySelector('[data-hrp-sticky-btn]'); if (btn) btn.tabIndex = past ? 0 : -1;
    }).observe(atc);
    sticky.querySelector('[data-hrp-sticky-btn]').addEventListener('click', function () {
      (box || root).scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { try { atc.focus({ preventScroll: true }); } catch (e) {} }, 500);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hrp-scroll-top]');
    if (!t) return; e.preventDefault();
    (box || root).scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
function hrpBoot() { document.querySelectorAll('[data-hrp]').forEach(hrpInit); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hrpBoot); else hrpBoot();
document.addEventListener('shopify:section:load', hrpBoot);
